const predefinedReasonList = [
    'Case should be invoiced at the end of the assignment',
    'Waiting until next invoicing cycle',
];

export const predefinedReasons: { id: number; name: string }[] = predefinedReasonList.map((reason, index) => ({
    id: index + 1,
    name: reason,
}));
